





















import {Component, Vue} from 'vue-property-decorator';
import {Action, State} from 'vuex-class';
import Heading from '@/components/Heading.vue';

@Component({
  components: {
    Heading,
  },
})
export default class ForgotPassword extends Vue {
  @State('email') public email?: string;
  @Action('forgotPassword') protected forgotPasswordAction: any;

  protected handleSubmit() {
    this.forgotPasswordAction({email: this.email});
  }
}
